import { useMemo } from 'react';

import { useTheme } from '@material-ui/core';
import { BiCheck, BiCheckDouble } from 'react-icons/bi';
import { TbClockHour4 } from 'react-icons/tb';
import { FiAlertCircle, FiUpload } from 'react-icons/fi';
import { RiCloseFill } from 'react-icons/ri';
import { MdOutlineSwapHoriz, MdOutlineTimelapse } from 'react-icons/md';

import { InviteStatus } from '../../../types';
import { INVITE_STATUS_LABELS } from '../config';

export const useInviteStatusOptions = () => {
  const theme = useTheme();

  const statusOptions = useMemo<Record<InviteStatus, { text: string; icon: JSX.Element }>>(
    () => ({
      accepted: {
        text: INVITE_STATUS_LABELS.accepted,
        icon: <BiCheck size={32} color={theme.palette.success.main} />,
      },
      automatically_accepted: {
        text: INVITE_STATUS_LABELS.automatically_accepted,
        icon: <BiCheckDouble size={32} color={theme.palette.success.main} />,
      },
      partially_accepted: {
        text: INVITE_STATUS_LABELS.partially_accepted,
        icon: <MdOutlineTimelapse size={28} color={theme.palette.warning.main} />,
      },
      pending: {
        text: INVITE_STATUS_LABELS.pending,
        icon: <TbClockHour4 size={32} color={theme.palette.text.primary} />,
      },
      not_sent: {
        text: INVITE_STATUS_LABELS.not_sent,
        icon: <FiAlertCircle size={32} color={theme.palette.warning.main} />,
      },
      not_accepted: {
        text: INVITE_STATUS_LABELS.not_accepted,
        icon: <RiCloseFill size={32} color={theme.palette.error.main} />,
      },
      sent: {
        text: INVITE_STATUS_LABELS.sent,
        icon: <FiUpload size={32} color={theme.palette.text.primary} />,
      },
      expired: {
        text: INVITE_STATUS_LABELS.expired,
        icon: <RiCloseFill size={32} color={theme.palette.error.main} />,
      },
      cancelled: {
        text: INVITE_STATUS_LABELS.cancelled,
        icon: <MdOutlineSwapHoriz size={30} color={theme.palette.text.secondary} />,
      },
    }),
    [
      theme.palette.error.main,
      theme.palette.success.main,
      theme.palette.text.primary,
      theme.palette.text.secondary,
      theme.palette.warning.main,
    ]
  );

  return { statusOptions };
};
